import { useEffect } from "react";
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { Link, NavLink, Navigate } from "react-router-dom";
import Timer from "../Timer/Timer";

import { MdOutlineCurrencyExchange } from "react-icons/md";
import { TbPlus, TbMinus } from "react-icons/tb";

const MobileListUi = ({
  roleName,
  timerStatus,
  index,
  _item,
  data,
  setData,
  resultModal,
  setResultModal,
  orderModal,
  setOrderModal,
  statePrice,
  setStatePrice,
  handlePriceChange,
  stateWeight,
  setStateWeight,
  handleWeightChange,
  stateTotal,
  setStateTotal,
  handleTotalChange,
  description,
  setDescription,
  addCommas,
  type,
  setType,
  handlePostTransaction,
  product_name,
  setProduct_name,
  setCustomeruser,
  userInfo,
  setBos,
  setIs_orderi,
  transactionId,
  setTransactionId,
  //* Timer Of Order
  isTimerOn,
  setIsTimerOn,
  handleStartTimer,
  //* Update Product
  handleChangeBuyPrice,
  handleChangeSellPrice,
  //* Is Price Close
  handleChangeBuyClosePriceProduct,
  handleChangeSellClosePriceProduct,
}) => {
  const removeWithoutBubble = (productName) => {
    if (!productName) return "";

    return productName
      .replace(/بدون حباب/g, "عادی")
      .replace(/بدونحباب/g, "عادی")
      .replace(/بدون_حباب/g, "عادی")
      .trim();
  };
  //* Timer Of Order
  useEffect(() => {
    const storedExpiryTime = localStorage.getItem("timerExpiryTime");
    if (storedExpiryTime) {
      const remainingTime = storedExpiryTime - new Date().getTime();
      if (remainingTime > 0) {
        setIsTimerOn(true);
        setTimeout(() => {
          localStorage.removeItem("timerExpiryTime");
          setIsTimerOn(false);
        }, remainingTime);
      }
    }
  }, []);

// راه‌حل صحیح
const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    // ساخت payload
    const payload = {
      product_name: _item.name,
      customeruser: userInfo[0]?.id,
      bos: type === 'buy' ? 'B' : 'S',
      is_orderi: type === 'buy' 
        ? _item.buy_price !== statePrice 
        : _item.sell_price !== statePrice,
      price: statePrice,
      volume: stateWeight,
      amount: stateTotal,
      description: description
    };
    
    // ارسال درخواست
    const result = await handlePostTransaction(payload);
    
    // اگر نتیجه موفقیت‌آمیز بود
    if (result?.status === 201 || result?.transactionId) {
      setTransactionId(result.transactionId);
      setResultModal(true);
      setOrderModal(true);
    }
  } catch (error) {
    console.error('Transaction error:', error);
    // نمایش خطا به کاربر
    setTransactionId(null);
    setResultModal(true);
    setOrderModal(true);
  }
};


  return (
    <>
      <tr key={index} className="hover:bg-boxColor w-full relative h-20">
        {/* Number */}
        <td className="py-4 pr-2">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-xs text-gray-900
              animate__animated animate__fadeIn animate__fast`}
          >
            {index + 1}
          </div>
        </td>
        {/* Product Name */}
        <td className="py-4">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-xs text-gray-900
              animate__animated animate__fadeIn animate__fast`}
          >
            {removeWithoutBubble(_item.name)}
          </div>
        </td>
        {/* Green Prices */}
        <td className="py-4">
          <div className="flex flex-col justify-center items-center space-y-2">
            {/* Price */}
            <div className="text-green-600 flex justify-center items-center">
              {/* Increase */}

              {/* Price */}
              <div
                onClick={() => {
                  setStateWeight("");
                  setStateTotal("");
                  setDescription("");
                  setData("");
                  setType("");
                  setStatePrice(_item.buy_price);
                  setData(_item);
                  setType("buy");
                }}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-medium
              cursor-pointer text-sm
              animate__animated animate__fadeIn animate__fast`}
              >
                {_item.buy_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.buy_price}
                    thousandSeparator=","
                  />
                )}
              </div>
              {/* Decrease */}
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_buy_closed ? "text-red-600" : "text-green-600"
                  } cursor-pointer text-sm`}
                >
                  {_item?.is_buy_closed ? (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                        )
                      }
                    >
                      قیمت خرید بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close,
                        )
                      }
                    >
                      قیمت خرید باز
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Red Prices */}
        <td className="py-4">
          <div className="flex flex-col justify-center items-center space-y-2">
            {/* Price */}
            <div className="text-red-600 flex justify-center items-center">
              {/* Price */}
              <div
                onClick={() => {
                  setStateWeight("");
                  setStateTotal("");
                  setDescription("");
                  setData("");
                  setType("");
                  setStatePrice(_item.sell_price);
                  setData(_item);
                  setType("sell");
                }}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-medium
                cursor-pointer text-sm
                animate__animated animate__fadeIn animate__fast`}
              >
                {_item.sell_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.sell_price}
                    thousandSeparator=","
                  />
                )}
              </div>
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_sell_closed ? "text-red-600" : "text-green-600"
                  } cursor-pointer text-sm`}
                >
                  {_item?.is_sell_closed ? (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close,
                        )
                      }
                    >
                      قیمت فروش بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close,
                        )
                      }
                    >
                      قیمت فروش باز
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Last Update */}
        <td className="py-4">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } justify-center text-gray-900 text-xs
            animate__animated animate__fadeIn animate__fast`}
          >
            {/* {formatToPersianDate(_item.last_update_time_ago)} */}
            {_item.last_update_time_ago}
          </div>
        </td>
        {/* Modal */}
        {_item?.id === data?.id && (
          <>
            <div
              className="flex bg-gray-300 bg-opacity-0 fixed lg:mr-40
            inset-0 items-center w-full z-50 mr-auto h-screen
            animate__animated animate__fadeIn animate__fast"
            >
              <div
                className="flex flex-col -mt-5 w-11/12 sm:w-5/6
                lg:w-12/12 max-w-2xl mx-auto rounded-lg 
              border-2 border-boxColor"
              >
                {/* Order Modal */}
                {orderModal && (
                  <>
                    {/* Title */}
                    <div
                      className="flex justify-center items-center
                   w-full p-6 bg-gray-300"
                    >
                      <p className="text-base font-medium text-black">
                        سفارش{" "}
                        <span
                          className={`${
                            type === "buy" ? "text-green-700" : "text-red-700"
                          }`}
                        >
                          {type === "buy" ? "خرید" : "فروش"}
                        </span>{" "}
                        برای " {removeWithoutBubble(_item?.name)} "
                      </p>
                    </div>
                    {/* Confirmation Of Order */}
                    <div
                      className="grid grid-cols-2 gap-y-4 justify-items-center pb-4
                      items-center w-full bg-gray-300 text-gray-900 text-base"
                    >
                      {/* Price */}
                      {statePrice ? (
                        <span className="flex flex-col items-center space-y-1">
                          <span>{_item.tag === "S" ? "قیمت" : "مظنه"} </span>
                          <span>
                            <PersianNumber
                              value={statePrice}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-1">
                          <span>{_item.tag === "S" ? "قیمت" : "مظنه"}</span>
                          <span>-</span>
                        </span>
                      )}
                      {/* Weight */}
                      {stateWeight ? (
                        <span className="flex flex-col items-center space-y-1">
                          <span>
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </span>
                          <span>
                            <PersianNumber
                              value={stateWeight}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center space-y-1">
                          <span>
                            {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                          </span>
                          <span>-</span>
                        </span>
                      )}
                      {/* Total */}
                      {stateTotal ? (
                        <span className="flex flex-col items-center">
                          <span>جمع کل</span>
                          <span>
                            <PersianNumber
                              value={stateTotal}
                              thousandSeparator=","
                            />
                          </span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center">
                          <span>جمع کل</span>
                          <span>-</span>
                        </span>
                      )}
                      {/* Description */}
                      {description ? (
                        <span
                          className="flex flex-col items-center
                          w-32 overflow-hidden text-ellipsis whitespace-nowrap"
                        >
                          <span>توضیحات</span>
                          <span>{description}</span>
                        </span>
                      ) : (
                        <span className="flex flex-col items-center">
                          <span>توضیحات</span>
                          <span>-</span>
                        </span>
                      )}
                    </div>
                    <span className="border-b-2 border-boxColor" />

                    {/* Result Modal */}
                    {!resultModal ? (
                      // *Inputs - Button
                      <>
                        <div className="w-full px-6 py-5 bg-gray-300 relative">
  <form onSubmit={handleSubmit}>
                            {/* Inputs */}
                            <div className="flex flex-col w-full">
                              {/* Order Icon */}
                              {type === "buy" && (
                                <>
                                  {_item.buy_price !== statePrice && (
                                    <span
                                      className="absolute px-2 py-1 rounded-full top-2
                              left-1 flex items-center text-slate-300"
                                    >
                                      <div className="group flex relative">
                                        <MdOutlineCurrencyExchange
                                          size={18}
                                          className="animate-spin-slow"
                                        />
                                        <span
                                          className="group-hover:opacity-0 transition-opacity 
                                  px-1 text-sm text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                        >
                                          اردری
                                        </span>
                                      </div>
                                    </span>
                                  )}
                                </>
                              )}
                              {type === "sell" && (
                                <>
                                  {_item.sell_price !== statePrice && (
                                    <span
                                      className="absolute px-2 py-1 rounded-full top-2
                              left-1 flex items-center text-slate-300"
                                    >
                                      <div className="group flex relative">
                                        <MdOutlineCurrencyExchange
                                          size={18}
                                          className="animate-spin-slow"
                                        />
                                        <span
                                          className="group-hover:opacity-0 transition-opacity 
                                  px-1 text-sm text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                        >
                                          اردری
                                        </span>
                                      </div>
                                    </span>
                                  )}
                                </>
                              )}

                              <span>
                                {/* Price */}
                                <span className="w-full">
                                  <label
                                    htmlFor="price"
                                    className="block mb-2 mr-2.5 text-sm font-medium text-black"
                                  >
                                    {_item.tag === "S" ? "قیمت" : "مظنه"}
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="price"
                                    value={
                                      statePrice === -1
                                        ? ""
                                        : statePrice === ""
                                          ? statePrice + statePrice
                                          : addCommas(statePrice)
                                    }
                                    onChange={(e) => {
                                      handlePriceChange(_item, e);
                                    }}
                                    className={`p-2 mb-2 bg-gray-300 border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-slate-800
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }
                   `}
                                  />
                                </span>
                                {/* Weight */}
                                <span className="w-full">
                                  <label
                                    htmlFor="weight"
                                    className="block mb-2 mr-2.5 text-sm font-medium text-black"
                                  >
                                    {_item.tag === "S"
                                      ? "تعداد"
                                      : "مقدار (گرم)"}
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="weight"
                                    value={stateWeight}
                                    onChange={(e) => {
                                      handleWeightChange(_item, e);
                                    }}
                                    className={`p-2 mb-2 bg-gray-300 border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-slate-800
                   ${
                     type === "buy"
                       ? "focus:border-green-600 focus:text-green-600"
                       : "focus:border-red-600 focus:text-red-600"
                   }`}
                                  />
                                </span>
                                {/* Total */}
                                <span className="w-full">
                                  <label
                                    htmlFor="total"
                                    className="block mb-2 mr-2.5 text-sm font-medium text-black"
                                  >
                                    جمع کل
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="total"
                                    value={addCommas(stateTotal)}
                                    onChange={(e) => {
                                      handleTotalChange(_item, e);
                                    }}
                                    className={`p-2 mb-2 bg-gray-300 border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-slate-800 
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }`}
                                  />
                                </span>
                                {/* Description */}
                                <span className="w-full">
                                  <label
                                    htmlFor="description"
                                    className="block mb-2 mr-2.5 text-sm font-medium text-black"
                                  >
                                    توضیحات
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    name="description"
                                    value={description ? description : ""}
                                    onChange={(e) =>
                                      setDescription(e.target.value)
                                    }
                                    className={`p-2 mb-2 bg-gray-300 border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-slate-800
                     ${
                       type === "buy"
                         ? "focus:border-green-600 focus:text-green-600"
                         : "focus:border-red-600 focus:text-red-600"
                     }`}
                                  />
                                </span>
                                {/* Other Items To Send */}
                                <div>
                                  {setProduct_name(_item.name)}
                                  {setCustomeruser(userInfo[0]?.id)}
                                  {type === "buy" ? setBos("B") : setBos("S")}
                                  {setIs_orderi(
                                    _item.buy_price !== statePrice
                                      ? true
                                      : false,
                                  )}
                                </div>
                              </span>
                            </div>
                            {/* Button */}
    <span className="flex justify-center w-full mt-5">
      <button
        type="button"
        className="text-slate-700 text-base tracking-wider mx-4"
        onClick={() => {
          setStatePrice("");
          setStateWeight("");
          setStateTotal("");
          setDescription("");
          setData("");
          setType("");
          setOrderModal(true);
          setResultModal(false);
        }}
      >
        لغو
      </button>
      {timerStatus ? (
        <Timer durationInSeconds={60} />
      ) : (
        <button
          type="submit"
          className={`${
            type === "buy"
              ? "bg-green-500 hover:bg-green-700"
              : "bg-red-500 hover:bg-red-700"
          } rounded-full px-3 py-0.5 mx-2 tracking-wider text-base text-black transition-all duration-100`}
        >
          {type === "buy" ? "خرید" : "فروش"}
        </button>
      )}
    </span>
  </form>
</div>
                      </>
                    ) : (
                      //*  Result Modal
                      <>
                        <div className="w-full px-6 py-5 bg-gray-300">
                          {transactionId ? (
                            <>
                              <div
                                className="flex flex-col justify-between items-center w-full h-full space-y-5
                              text-slate-300 text-base animate__animated animate__fadeIn animate__fast"
                              >
                                <span className="flex flex-col justify-around items-center w-full space-y-2">
                                  {/* Text */}
                                  <span
                                    className={`${
                                      type === "buy"
                                        ? "text-green-600"
                                        : "text-red-600"
                                    }
                                font-bold text-center tracking-wide`}
                                  >
                                    {type === "buy" ? "خرید " : "فروش "}
                                    <span className="text-slate-700">
                                      شما ثبت گردید به صفحه معاملات رجوع کنید
                                    </span>
                                  </span>
                                  {/* Transaction Id */}
                                  <span className="font-medium flex tracking-wider text-zinc-300">
                                    <span>شماره سفارش : </span>
                                    <span>#{transactionId}</span>
                                  </span>
                                </span>

                                {/* Timer */}
                                {timerStatus && (
                                  <Timer durationInSeconds={60} />
                                )}

                                {/* Button */}
                                <span className="w-3/12 flex justify-center ">
                                  <NavLink to="/Public/Live-Transactions">
                                    <button
                                      onClick={() => {
                                        setStatePrice("");
                                        setStateWeight("");
                                        setStateTotal("");
                                        setData("");
                                        setType("");
                                        setOrderModal(true);
                                        setResultModal(false);
                                      }}
                                      className="bg-yellow-500 hover:bg-green-700 text-slate-700 rounded-full px-4 py-1 transition-colors"
                                    >
                                      معاملات جاری
                                    </button>
                                  </NavLink>
                                  <button
                                    onClick={() => {
                                      setStatePrice("");
                                      setStateWeight("");
                                      setStateTotal("");
                                      setData("");
                                      setType("");
                                      setOrderModal(true);
                                      setResultModal(false);
                                    }}
                                    className="rounded-full px-3 py-0.5 mx-2
                                tracking-wider text-base text-black 
                                bg-green-500 hover:bg-green-700
                                transition-all duration-100 ease-linear
                                hover:transition-all hover:duration-100 hover:ease-linear"
                                  >
                                    بستن
                                  </button>
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="flex flex-col justify-center items-center w-full h-full
                          space-y-5 animate__animated animate__fadeIn animate__fast"
                              >
                                <span
                                  className="flex items-center justify-center 
                            w-full text-slate-700 text-base font-bold text-center"
                                >
                                  <span className="flex flex-col justify-around items-center w-full space-y-2">
                                    {/* Text */}
                                    <span
                                      className={`${
                                        type === "buy"
                                          ? "text-green-600"
                                          : "text-red-600"
                                      }
                                font-bold text-center tracking-wide`}
                                    >
                                      {type === "buy" ? "خرید " : "فروش "}
                                      <span className="text-slate-700">
                                        شما ثبت گردید به صفحه معاملات رجوع کنید
                                      </span>
                                    </span>
                                    {/* Transaction Id */}
                                    <span className="font-medium flex tracking-wider text-zinc-300">
                                      <span>شماره سفارش : </span>
                                      <span>#{transactionId}</span>
                                    </span>
                                  </span>
                                </span>
                                <span className="w-3/12 flex justify-center ">
                                  <NavLink to="/Public/Live-Transactions">
                                    <button
                                      onClick={() => {
                                        setStatePrice("");
                                        setStateWeight("");
                                        setStateTotal("");
                                        setData("");
                                        setType("");
                                        setOrderModal(true);
                                        setResultModal(false);
                                      }}
                                      className="bg-yellow-500 hover:bg-green-700 text-slate-700 rounded-full px-4 py-1 transition-colors"
                                    >
                                      معاملات جاری
                                    </button>
                                  </NavLink>
                                  <button
                                    onClick={() => {
                                      setStatePrice("");
                                      setStateWeight("");
                                      setStateTotal("");
                                      setData("");
                                      setType("");
                                      setOrderModal(true);
                                      setResultModal(false);
                                    }}
                                    className="rounded-full px-3 py-0.5 mx-2
                                tracking-wider text-base text-black 
                                bg-green-500 hover:bg-green-700
                                transition-all duration-100 ease-linear
                                hover:transition-all hover:duration-100 hover:ease-linear"
                                  >
                                    بستن
                                  </button>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </tr>
    </>
  );
};

export default MobileListUi;
